import { render, staticRenderFns } from "./newProductOverview.vue?vue&type=template&id=b3f5f4a6&scoped=true&"
import script from "./newProductOverview.vue?vue&type=script&lang=js&"
export * from "./newProductOverview.vue?vue&type=script&lang=js&"
import style0 from "./newProductOverview.vue?vue&type=style&index=0&id=b3f5f4a6&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f5f4a6",
  null
  
)

export default component.exports